import React from 'react';
import { Download, ExternalLink, FileText } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

const PDFViewer = ({ url, title, allowDownload = true }) => {
  // Debug logging
  console.log('PDFViewer - URL:', url);
  console.log('PDFViewer - Title:', title);

  if (!url) {
    return (
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-6 text-center">
        <p className="text-amber-700">No PDF URL provided.</p>
      </div>
    );
  }

  // Due to CSP restrictions, we'll provide a clean interface to open/download the PDF
  // rather than trying to embed it
  return (
    <Card className="border-gray-200">
      <CardContent className="p-8">
        <div className="text-center space-y-6">
          {/* PDF Icon */}
          <div className="flex justify-center">
            <div className="h-24 w-24 rounded-full bg-red-100 flex items-center justify-center">
              <FileText className="h-12 w-12 text-red-600" />
            </div>
          </div>

          {/* Title and Description */}
          <div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              {title || 'Meeting Minutes PDF'}
            </h3>
            <p className="text-gray-600 text-sm">
              Click the button below to view or download this PDF document.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
            <Button
              size="lg"
              onClick={() => window.open(url, '_blank')}
              className="bg-emerald-600 hover:bg-emerald-700 min-w-[200px]"
            >
              <ExternalLink className="h-5 w-5 mr-2" />
              Open PDF
            </Button>

            {allowDownload && (
              <Button
                variant="outline"
                size="lg"
                onClick={() => {
                  const link = document.createElement('a');
                  link.href = url;
                  link.download = title || 'document.pdf';
                  link.target = '_blank';
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }}
                className="min-w-[200px]"
              >
                <Download className="h-5 w-5 mr-2" />
                Download PDF
              </Button>
            )}
          </div>


          {/* Embedded viewer attempt with object tag */}
          <div className="mt-6">
            <div className="bg-gray-100 rounded-lg p-4 border border-gray-200" style={{ height: '600px' }}>
              <object
                data={url}
                type="application/pdf"
                className="w-full h-full"
                aria-label={title || 'PDF Document'}
              >
                <div className="flex items-center justify-center h-full">
                  <div className="text-center">
                    <p className="text-gray-600 mb-4">
                      Your browser cannot display PDFs inline.
                    </p>
                    <Button
                      onClick={() => window.open(url, '_blank')}
                      className="bg-emerald-600 hover:bg-emerald-700"
                    >
                      <ExternalLink className="h-4 w-4 mr-2" />
                      Open PDF in New Tab
                    </Button>
                  </div>
                </div>
              </object>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default PDFViewer;

